// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../../hooks/useMergeProps';

import BoomNavIcon from './BoomNavIcon';
import selectBoomNavIconProps from './BoomNavIcon.selector';

type PropsType = {
  className?: string;
  disabledAnimation?: boolean;
  isActive?: boolean;
  'data-testid'?: string;
};

const BoomNavIconContainer = (ownProps: PropsType) => {
  const selectedProps = useSelector(selectBoomNavIconProps);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <BoomNavIcon {...enhancedProps} />;
};

export default BoomNavIconContainer;
